(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3089],{

/***/ 99859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgStar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.986 3.797a.297.297 0 00-.237-.209l-3.1-.472L5.263.171A.292.292 0 005 0a.292.292 0 00-.263.171L3.351 3.116l-3.1.472a.297.297 0 00-.237.21.317.317 0 00.074.314l2.244 2.292-.53 3.237a.314.314 0 00.117.3.284.284 0 00.308.024L5 8.437l2.773 1.528a.282.282 0 00.308-.024.314.314 0 00.117-.3l-.53-3.237 2.244-2.292a.317.317 0 00.074-.315z",
    fill: "#F0B31F"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgStar);

/***/ }),

/***/ 75006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgTrustedShopBadge(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.187 14.332c-1.1 1.626-2.63 3.108-4.687 3.108-2.175 0-3.442-1.362-3.442-3.562 0-3.561 2.63-7.052 6.335-7.052 1.242 0 2.916.502 2.916 2.009 0 2.7-4.231 3.609-6.311 4.135-.072.457-.143.908-.143 1.362 0 .933.501 1.793 1.53 1.793 1.338 0 2.412-1.29 3.203-2.247zm-1.148-5.808c0-.55-.31-.978-.884-.978-1.722 0-2.608 3.346-2.94 4.66 1.601-.48 3.824-1.794 3.824-3.682zM12 0a12 12 0 1012 11.997A11.997 11.997 0 0012 0zm-.1 19.523a7.563 7.563 0 117.564-7.563 7.563 7.563 0 01-7.563 7.56z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgTrustedShopBadge);

/***/ }),

/***/ 21972:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/food-program",
      function () {
        return __webpack_require__(66237);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20775:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/check-icon.fb9b5114.png","height":30,"width":38,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJFBMVEWOlUR/kV55ilh9kFx/kV2HmWJ+kVuDlmGClGB1iWJ8j1yOo2muPhQvAAAAC3RSTlMBpiS9Yf165+kNl2fPTIwAAAAJcEhZcwAACxMAAAsTAQCanBgAAAArSURBVHicJcm5EQAgDMAw5wey/74cwY0KwyT2taW4g5SCdGbo7A6fv+08LwmuAG4rgpSIAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 66237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ food_program; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./src/shared/layouts/MainLayout.tsx + 1 modules
var MainLayout = __webpack_require__(89452);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Hidden/Hidden.js + 3 modules
var Hidden = __webpack_require__(53450);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/hero.png
/* harmony default export */ var hero = ({"src":"/_next/static/media/hero.c74961c4.png","height":886,"width":882,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAflBMVEVMaXGHa16bXUp9cXF3c3NyYl2fn53+/v6srayWfGn/xgDYkCG/v7nFbBDh392ngVLMfhp/dXOFZDvT09H/mwj/kABXY2yho6SocFOvhWgpKSm0tbbvhgFKPUetiHKtgnSNhIPBdhHFkleRh4KDYVS2jn+9fTT08Oy2oJ6mhoSr7uxMAAAAI3RSTlMA+/4f/j9T/cv+CS4wxvzY1uio/ZoeV/uW/U/Qxfu/1fHyoCA/UIcAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABESURBVHicBcEFAoAgAACxA1HA7u72/x90A6px2x2A8p7e1QU/PTvxzUBkrZQLTp0fSlwtvWqKOEsCvEdrHQLeYIxx4QePqwOasvaWuAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./public/artifacts/images/homepage/redesign/check-icon.png
var check_icon = __webpack_require__(20775);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/shared/services/trustedShops/handleRatings.ts
var handleRatings = __webpack_require__(95046);
// EXTERNAL MODULE: ./src/shared/components/FlexBox.tsx
var FlexBox = __webpack_require__(85249);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/static_pages/foodProgram/Customers.tsx + 8 modules
var Customers = __webpack_require__(43518);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 4 modules
var Box = __webpack_require__(65576);
// EXTERNAL MODULE: ./public/artifacts/icons/star.svg
var star = __webpack_require__(99859);
// EXTERNAL MODULE: ./public/artifacts/icons/trusted-shop-badge.svg
var trusted_shop_badge = __webpack_require__(75006);
;// CONCATENATED MODULE: ./src/static_pages/home/components/Hero/Ratings.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n\n  ",
        " {\n    margin-top: ",
        "px;\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  gap: ",
        "px;\n\n  padding-bottom: ",
        "px;\n  padding-top: ",
        "px;\n  padding-right: ",
        "px;\n\n  ",
        " {\n    flex-direction: column;\n    padding-bottom: ",
        "px;\n    width: 100%;\n    gap: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 172.5%;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 172.5%;\n  align-self: center;\n  white-space: nowrap;\n  padding-left: ",
        "px;\n\n  color: #273635;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 100px;\n\n  background-color: ",
        ";\n\n  margin-left: ",
        "px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 30px;\n  min-width: 30px;\n\n  ",
        " {\n    height: 46px;\n    min-width: 46px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        "px;\n  background-color: #f9fcea;\n\n  ",
        " {\n    background-color: inherit;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var Ratings = function(param) {
    var rating = param.rating;
    var isTablet = (0,useBreakpoints/* useBreakpointUp */._)("lg");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(trusted_shop_badge/* default */.Z, {
                    fill: "white",
                    height: isTablet ? "22px" : "16px",
                    width: isTablet ? "22px" : "16px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                pr: 3.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                        children: Array(Math.ceil(rating)).fill(1).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(star/* default */.Z, {
                                height: "10px",
                                width: "10px"
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingNumber, {
                                children: [
                                    rating.toFixed(1),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingFrom, {
                                children: "/ 5.0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var RatingText = styled_components_browser_esm["default"].div(_templateObject());
var Stars = styled_components_browser_esm["default"].div(_templateObject1(), function(param) {
    var spacing = param.theme.spacing;
    return spacing(0.4);
}, function(param) {
    var breakpoints = param.theme.breakpoints;
    return breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0.5);
});
var ContentWrapper = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var RatingNumber = styled_components_browser_esm["default"].div(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary.main;
});
var RatingFrom = styled_components_browser_esm["default"].div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var IconWrapper = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary.main;
}, function(param) {
    var spacing = param.theme.spacing;
    return spacing(1.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var Wrapper = styled_components_browser_esm["default"].div(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
/* harmony default export */ var Hero_Ratings = (Ratings);

// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/HeroBenefits.tsx

function HeroBenefits_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 90vw;\n  height: 1px;\n  background-color: #d0d0d0;\n  margin-top: ",
        "px;\n\n  ",
        " {\n    width: 1px;\n    margin-top: 0px;\n    height: 70px;\n  }\n"
    ]);
    HeroBenefits_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroBenefits_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 14px;\n  min-width: 100px;\n  line-height: 1.5;\n  color: #565b58;\n  padding-top: ",
        "px;\n\n  ",
        " {\n    font-size: 16px;\n  }\n\n  ",
        " {\n    font-size: 18px;\n  }\n\n  ",
        " {\n    padding-top: 0px;\n    margin-right: ",
        "px;\n  }\n"
    ]);
    HeroBenefits_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var HeroBenefits = function(param) {
    var rating = param.rating;
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        bgcolor: "#F8FBE5",
        display: "flex",
        alignItems: "center",
        height: {
            xs: "auto",
            lg: "93px"
        },
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            size: "sm",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                display: "flex",
                flexDirection: {
                    xs: "column",
                    lg: "row"
                },
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* default */.Z, {
                        flexDirection: {
                            xs: "column",
                            lg: "row"
                        },
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerCountText, {
                                textAlign: "center",
                                component: "span",
                                children: t("benefits.customerCount", {
                                    count: constants/* BENEFITS.CUSTOMER_COUNT */.pV.CUSTOMER_COUNT
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                pl: {
                                    xs: 1,
                                    lg: 4
                                },
                                pt: {
                                    xs: 2,
                                    lg: 0
                                },
                                pr: {
                                    xs: 1,
                                    lg: 3
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Customers/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                        mdDown: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* default */.Z, {
                        ml: {
                            xs: 0,
                            lg: 1
                        },
                        flexDirection: {
                            xs: "column",
                            lg: "row"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Ratings, {
                            rating: rating
                        })
                    })
                ]
            })
        })
    });
};
var Divider = styled_components_browser_esm["default"].div(HeroBenefits_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var CustomerCountText = (0,styled_components_browser_esm["default"])(esm.Typography)(HeroBenefits_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
/* harmony default export */ var foodProgram_HeroBenefits = (HeroBenefits);

// EXTERNAL MODULE: ./src/static_pages/foodProgram/useFoodProgramCta.ts
var useFoodProgramCta = __webpack_require__(31006);
// EXTERNAL MODULE: ./src/static_pages/foodProgram/Utils.tsx
var Utils = __webpack_require__(54397);
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/Hero.tsx




function Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  z-index: 2;\n  ",
        " {\n    overflow: visible;\n  }\n"
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 1;\n"
    ]);
    Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #3e3e3e;\n  font-size: 16px;\n  text-align: center;\n  font-weight: 400;\n  padding: 0px;\n  line-height: 168%; /* 33.6px */\n\n  ",
        " {\n    text-align: start;\n  }\n  ",
        " {\n    font-size: 20px;\n  }\n"
    ]);
    Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 0 auto;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  max-width: 70vw;\n\n  list-style: none;\n  padding: 0px;\n\n  ",
        " {\n    margin: ",
        ";\n    align-items: flex-start;\n  }\n"
    ]);
    Hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Hero_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  color: #3e3e3e;\n  margin: 0px;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 172.5%;\n\n  ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    Hero_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Hero_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n"
    ]);
    Hero_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Hero_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  margin: ",
        ";\n\n  ",
        " {\n    margin: ",
        ";\n    align-items: flex-start;\n  }\n"
    ]);
    Hero_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
















function Hero(_param) {
    var ratings = _param.ratings, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "ratings"
    ]);
    var theme = (0,styled_components_browser_esm.useTheme)();
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    var ctaHref = (0,useFoodProgramCta/* useFoodProgramCta */.b)();
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var i18Benefits = t("hero.benefits.items", {
        returnObjects: true
    });
    var benefits = Array.isArray(i18Benefits) ? i18Benefits : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                as: "section",
                width: "100%"
            }, boxProps), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        size: 1268,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                            display: "flex",
                            justifyContent: {
                                xs: "flex-start",
                                md: "center"
                            },
                            my: {
                                xs: 4,
                                md: 6
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                    display: "block",
                                    width: "100%",
                                    textAlign: {
                                        xs: "center",
                                        md: "start"
                                    },
                                    pr: {
                                        xs: 0,
                                        md: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Utils/* FoodProgramH1 */.U, {
                                            mb: 5,
                                            children: [
                                                t("hero.title"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                                    as: "span",
                                                    color: theme.palette.secondary[400],
                                                    children: [
                                                        " ",
                                                        t("hero.titleHighlight")
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Benefits, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsTitle, {
                                                    children: t("hero.benefits.title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsList, {
                                                    children: benefits.map(function(benefit) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Benefit, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                                                    flexShrink: 0,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        alt: "",
                                                                        src: check_icon/* default */.Z,
                                                                        layout: "fixed",
                                                                        width: mobile ? 34 : 38,
                                                                        height: mobile ? 27 : 30
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTypography, {
                                                                    children: benefit
                                                                })
                                                            ]
                                                        }, benefit);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                            display: "flex",
                                            mx: {
                                                xs: "auto",
                                                md: 0
                                            },
                                            flexDirection: "column",
                                            alignItems: "center",
                                            width: {
                                                xs: "fit-content"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                                    mb: 2,
                                                    fontWeight: 600,
                                                    fontSize: 16,
                                                    children: t("hero.ctaLabelTop")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Button, {
                                                    component: "a",
                                                    target: "_blank",
                                                    href: ctaHref,
                                                    rounded: true,
                                                    size: "lg",
                                                    block: true,
                                                    children: t("cta")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Typography, {
                                                    mt: 2,
                                                    children: [
                                                        " ",
                                                        t("hero.ctaLabelBottom")
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                    smDown: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                        flexShrink: 0,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            alt: "",
                                            priority: true,
                                            src: hero,
                                            width: 441,
                                            height: 443,
                                            objectFit: "cover"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(foodProgram_HeroBenefits, {
                rating: (0,handleRatings/* getRating */.h1)(ratings)
            })
        ]
    });
}
var Hero_Wrapper = styled_components_browser_esm["default"].div(Hero_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Content = styled_components_browser_esm["default"].div(Hero_templateObject1());
var BenefitTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(Hero_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var BenefitsList = styled_components_browser_esm["default"].ul(Hero_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 0);
});
var BenefitsTitle = styled_components_browser_esm["default"].h2(Hero_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var Benefit = styled_components_browser_esm["default"].li(Hero_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var Benefits = styled_components_browser_esm["default"].div(Hero_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 0, 3, 0);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 0, 6, 0);
});
/* harmony default export */ var foodProgram_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/what-is-it.png
/* harmony default export */ var what_is_it = ({"src":"/_next/static/media/what-is-it.a33414d6.png","height":778,"width":934,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAOVBMVEXS1NTx8e3V2cjJupD19/jr7u/4+/3////k6ezu8fXZ0L/FxcXQ07GmnaXg3dd7cnXw3cljVGnbva/hSKYeAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADZJREFUeJwFwQkCwCAIA7CilBZ37/+PNYFEOyUUbbqFMqNtIeaZPUaB839joZDX99wHBBU7U9oupwGGt7ZdkwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/WhatIsFoodProgram.tsx











var WhatIsFoodProgram = function(props) {
    var theme = (0,styled_components_browser_esm.useTheme)();
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        size: 1050,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            as: "section",
            display: "flex",
            flexDirection: {
                xs: "column",
                md: "row"
            },
            alignItems: "center"
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    flexShrink: {
                        xs: 0.8,
                        sm: 0.2,
                        lg: 0
                    },
                    maxWidth: {
                        xs: 300,
                        md: "none"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        src: what_is_it,
                        width: 467,
                        height: 389,
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                    display: "flex",
                    ml: {
                        xs: 0,
                        sm: 2,
                        md: 6,
                        lg: 8
                    },
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils/* FoodProgramH2 */.s, {
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                t: t,
                                i18nKey: "whatItIs.title",
                                components: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                        as: "span",
                                        color: {
                                            xs: "inherit",
                                            md: theme.palette.secondary[400]
                                        }
                                    }, "1"), 
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            lineHeight: 1.68,
                            fontSize: {
                                xs: 14,
                                sm: 16
                            },
                            children: t("whatItIs.description")
                        })
                    ]
                })
            ]
        }))
    });
};
/* harmony default export */ var foodProgram_WhatIsFoodProgram = (WhatIsFoodProgram);

;// CONCATENATED MODULE: ./src/pages/food-program.tsx








var FooterLinks = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6029).then(__webpack_require__.bind(__webpack_require__, 6029));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6029)
            ];
        }
    }
});
var Advantages = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4312).then(__webpack_require__.bind(__webpack_require__, 64312));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64312)
            ];
        }
    }
});
var BottomCTA = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8547).then(__webpack_require__.bind(__webpack_require__, 78547));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78547)
            ];
        }
    }
});
var Companies = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3772).then(__webpack_require__.bind(__webpack_require__, 53772));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53772)
            ];
        }
    }
});
var CustomerExamples = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4489).then(__webpack_require__.bind(__webpack_require__, 14489));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14489)
            ];
        }
    }
});
var FAQs = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2311), __webpack_require__.e(6649), __webpack_require__.e(8844)]).then(__webpack_require__.bind(__webpack_require__, 82632));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82632)
            ];
        }
    }
});
var FindTheRightProgram = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3007).then(__webpack_require__.bind(__webpack_require__, 63007));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63007)
            ];
        }
    }
});
var FoodProgramSteps = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9990).then(__webpack_require__.bind(__webpack_require__, 69990));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69990)
            ];
        }
    }
});
var NumericHighlights = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4164).then(__webpack_require__.bind(__webpack_require__, 14164));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14164)
            ];
        }
    }
});
var OurServices = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7569).then(__webpack_require__.bind(__webpack_require__, 27569));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27569)
            ];
        }
    }
});
var FoodProgramPage = function(param) {
    var ratings = param.ratings;
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
        ratings: ratings,
        renderNavbarCta: function() {
            return null;
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("meta.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("meta.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(foodProgram_Hero, {
                ratings: ratings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(foodProgram_WhatIsFoodProgram, {
                mt: {
                    xs: 3,
                    sm: 9
                },
                mb: {
                    xs: 4,
                    sm: 9
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurServices, {
                mt: {
                    xs: 3,
                    sm: 9
                },
                mb: {
                    xs: 10,
                    sm: 15
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Companies, {
                mb: {
                    xs: 10,
                    md: 15
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindTheRightProgram, {
                mb: 21
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Advantages, {
                mb: 9
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericHighlights, {
                mb: 11
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerExamples, {
                mb: {
                    xs: 5,
                    md: 15
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoodProgramSteps, {
                mb: {
                    xs: 6,
                    md: 15
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs, {
                mb: {
                    xs: 4,
                    md: 9
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCTA, {
                mb: {
                    xs: 0,
                    md: 8
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks, {
                pb: {
                    xs: 2,
                    sm: 6
                },
                pt: {
                    xs: 2,
                    sm: 3
                }
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var food_program = (FoodProgramPage);


/***/ }),

/***/ 85249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65576);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Utility component with the same API as Box
 *
 * Differences:
 * - `display="flex"` is automatically applied.
 * - Accepts a `gap` property
 */ var FlexBox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var _display = _param.display, display = _display === void 0 ? "flex" : _display, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "display"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BoxWithGaps, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        display: display,
        ref: ref
    }, props));
});
FlexBox.displayName = "FlexBox";
var BoxWithGaps = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject(), function(param) {
    var gap = param.gap;
    return gap ? gap * 8 : 0;
});
/* harmony default export */ __webpack_exports__["Z"] = (FlexBox);


/***/ }),

/***/ 20486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      pointer-events: none;\n      color: ",
        ";\n      cursor: default;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  text-decoration: none;\n  border-radius: 4px;\n  padding: ",
        ";\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: ",
        ";\n  margin: 0 4px;\n\n  &:hover {\n    background-color: ",
        ";\n    color: black;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function Locale() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("nav", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "sr-only",
                children: "Language switcher"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: router.asPath,
                passHref: true,
                locale: "de",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                    selected: router.locale === "de",
                    children: "DE"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: router.asPath,
                passHref: true,
                locale: "en",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                    selected: router.locale === "en",
                    children: "EN"
                })
            })
        ]
    });
}
var ToggleButton = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].a(_templateObject1(), function(props) {
    return props.theme.spacing(1, 1);
}, function(props) {
    return props.theme.palette.grey[600];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.selected && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), function(props) {
        return props.theme.palette.common.white;
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Locale);


/***/ }),

/***/ 4285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ legalEntityName; }
/* harmony export */ });
var DEFAULT_LEGAL_ENTITY = "Hey Group GmbH";
var LEGAL_ENTITY_BY_LOCALE = {
    "en-uk": "HEYCATER! UK LTD"
};
function legalEntityName(locale) {
    return locale && LEGAL_ENTITY_BY_LOCALE[locale.toLowerCase()] || DEFAULT_LEGAL_ENTITY;
}


/***/ }),

/***/ 89452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ PageLayout; },
  "Z": function() { return /* binding */ layouts_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Facebook.js
var Facebook = __webpack_require__(83792);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LinkedIn.js
var LinkedIn = __webpack_require__(20551);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Twitter.js
var Twitter = __webpack_require__(44704);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/shared/components/CookieContextProvider.tsx + 1 modules
var CookieContextProvider = __webpack_require__(82293);
// EXTERNAL MODULE: ./src/shared/components/Locale.js
var Locale = __webpack_require__(20486);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/legalEntity.ts
var legalEntity = __webpack_require__(4285);
// EXTERNAL MODULE: ./src/shared/svg/Logo.js
var Logo = __webpack_require__(37582);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/layouts/Footer.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  display: flex;\n  align-items: start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: inherit;\n  border: inherit;\n  line-height: 23px;\n  height: inherit;\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  cursor: pointer;\n  display: inline-block;\n\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: ",
        ";\n  color: white;\n  border: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: ",
        ";\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  display: flex;\n\n  ",
        " {\n    margin: ",
        ";\n    display: flex;\n    text-decoration: none;\n    list-style: none;\n    padding: 0;\n    flex-direction: ",
        ";\n    align-items: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  display: inline-block;\n  cursor: pointer;\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  cursor: pointer;\n  margin: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #9cba6c;\n  text-decoration: none;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
















var YEAR = new Date().getFullYear();
function Footer() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref = (0,react.useContext)(CookieContextProvider/* CookieContext */.U), detailsOpen = ref.detailsOpen, setDetailsOpen = ref.setDetailsOpen;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
            className: "main-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                    alt: "",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                fontSize: 12,
                                color: "white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Locale/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                                as: "nav",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "sr-only",
                                        children: "Social Links"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.linkedin.com/company/heycater/",
                                        "aria-label": "Linkedin",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.facebook.com/heycater",
                                        "aria-label": "Facebook",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://twitter.com/HeyHeycater",
                                        "aria-label": "Twitter",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
                        flexDirection: "column",
                        as: "nav",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                            mobileColumn: true,
                            as: "ul",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/impressum",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.imprint")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/agb",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.terms")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/datenschutz",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.privacy")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                        as: "button",
                                        onClick: function() {
                                            return setDetailsOpen(!detailsOpen);
                                        },
                                        children: "Cookies"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: constants/* LINKS.career */.BA.career,
                                        rel: "noopener",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerLink, {
                                            target: "_blank",
                                            children: t("common:navigation.career")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/about-us",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: "About us"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/hub",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.blog")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/partner-page",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterLink, {
                                            children: [
                                                "\uD83E\uDDD1‍\uD83C\uDF73 ",
                                                t("common:navigation.partner")
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTypography, {
                        pt: 2,
                        fontSize: 12,
                        children: [
                            YEAR,
                            " ",
                            (0,legalEntity/* legalEntityName */.t)(locale)
                        ]
                    })
                ]
            })
        })
    });
}
var NavListItem = styled_components_browser_esm["default"].li(_templateObject());
var StyledLink = styled_components_browser_esm["default"].a(_templateObject1(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var StyledFooter = styled_components_browser_esm["default"].div(_templateObject2(), function(props) {
    return props.theme.spacing(4, 0);
}, function(props) {
    return props.theme.palette.text.primary;
});
var FooterWrapper = styled_components_browser_esm["default"].div(_templateObject3(), function(props) {
    return props.flexDirection;
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var FooterColumn = styled_components_browser_esm["default"].div(_templateObject4(), function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(1, 0);
}, function(props) {
    return props.mobileColumn ? "column" : "row";
});
var FooterLink = styled_components_browser_esm["default"].a(_templateObject5(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var FooterSocialIconLink = styled_components_browser_esm["default"].a(_templateObject6(), function(props) {
    return props.theme.spacing(0, 1.75);
});
var StyledTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject7(), function(props) {
    return props.theme.palette.grey[400];
});
var CareerLink = (0,styled_components_browser_esm["default"])(FooterLink)(_templateObject8());
/* harmony default export */ var layouts_Footer = (Footer);

// EXTERNAL MODULE: ./src/shared/layouts/Navigation.tsx + 2 modules
var Navigation = __webpack_require__(48107);
;// CONCATENATED MODULE: ./src/shared/layouts/MainLayout.tsx






function MainLayout(param) {
    var children = param.children, _hideNavigationLinks = param.hideNavigationLinks, hideNavigationLinks = _hideNavigationLinks === void 0 ? false : _hideNavigationLinks, _hideNavbar = param.hideNavbar, hideNavbar = _hideNavbar === void 0 ? false : _hideNavbar, renderNavbarCta = param.renderNavbarCta, ratings = param.ratings;
    if (hideNavbar) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
            main: children,
            footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* default */.Z, {
            ratings: ratings,
            hideNavigationLinks: hideNavigationLinks,
            renderCTA: renderNavbarCta
        }),
        main: children,
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
    });
}
MainLayout.propTypes = {
    children: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node, 
    ]).isRequired
};
var PageLayout = function(param) {
    var header = param.header, main = param.main, footer = param.footer, root = param.root;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        position: "sticky",
                        top: "0",
                        zIndex: "100",
                        style: {
                            background: "white"
                        },
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        as: "main",
                        display: "flex",
                        overflow: "clip",
                        flexDirection: "column",
                        flexGrow: "1",
                        children: main
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        as: "footer",
                        mt: "auto",
                        children: footer
                    })
                ]
            }),
            root
        ]
    });
};
/* harmony default export */ var layouts_MainLayout = (MainLayout);


/***/ }),

/***/ 43518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ foodProgram_Customers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/icons/logo/bitkom.svg
var _style, _g, _path;
function bitkom_extends() { return bitkom_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, bitkom_extends.apply(null, arguments); }

function SvgBitkom(props) {
  return /*#__PURE__*/react.createElement("svg", bitkom_extends({
    id: "bitkom_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 479.97 116.03",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".bitkom_svg__st16{fill:#565b58}")), _g || (_g = /*#__PURE__*/react.createElement("g", {
    id: "bitkom_svg__chVvOh_tif"
  }, /*#__PURE__*/react.createElement("path", {
    className: "bitkom_svg__st16",
    d: "M479.97 114.46H451.2v-2.4c-.02-15.93-.02-31.86-.08-47.79-.01-1.77-.26-3.58-.64-5.32-1.4-6.42-6.11-9.42-12.55-8.06-5.64 1.18-9.54 4.71-12.45 9.47-3.11 5.09-4.49 10.73-4.58 16.63-.13 7.93-.01 15.87-.06 23.8-.01 1.27.31 1.72 1.67 1.86 2.92.29 5.81.83 8.7 1.38.47.09 1.19.7 1.2 1.09.1 3.05.06 6.1.06 9.26h-27.89v-2.45c0-15.55.02-31.09-.02-46.64-.01-1.97-.18-3.97-.54-5.9-1.25-6.75-6-9.88-12.76-8.45-6.51 1.37-10.51 5.78-13.38 11.39-2.37 4.62-3.49 9.59-3.52 14.78-.04 7.74-.01 15.48-.01 23.22v1.99c3.11.47 6.11 1 9.13 1.36 1.83.22 2.65.88 2.49 2.9-.21 2.53-.05 5.09-.05 7.77h-41.21c0-3.11-.04-6.22.05-9.32.01-.33.71-.84 1.15-.92 3.4-.59 6.8-1.15 10.22-1.6 1.21-.16 1.75-.48 1.74-1.86-.05-15.93-.05-31.86 0-47.79 0-1.26-.32-1.85-1.63-1.97-2.86-.27-5.71-.64-8.57-.98-.94-.11-1.87-.22-2.98-.36 0-3.13-.04-6.13.05-9.12.01-.38.62-1.02 1-1.06 9.16-.85 18.33-1.39 27.84-.89-.3 4.82-.6 9.48-.91 14.49.42-.73.71-1.2.98-1.68 6.08-11.31 19.81-17.02 32.15-13.38 6.38 1.88 10.51 6.08 12.7 12.28.3.84.55 1.69.73 2.25 2.35-2.79 4.45-5.97 7.2-8.43 8.13-7.28 17.69-8.81 27.93-5.6 7.8 2.45 11.22 8.64 12.5 16.24.4 2.38.55 4.83.56 7.25.05 12.6.03 25.21.03 37.81v2.38c4.26.68 8.4 1.34 12.54 1.99-.02 3.47-.02 6.93-.02 10.38zM215.79 2.74v70.19c6.76-7.67 13.18-14.95 19.77-22.44-2.43-.46-4.6-.82-6.73-1.33-.53-.13-1.33-.76-1.35-1.19-.12-2.99-.06-5.98-.06-9.12h38.31c0 3.09.05 6.15-.06 9.19-.01.38-.75.98-1.23 1.07-2.57.48-5.17.8-7.75 1.26-.71.13-1.57.34-2.03.83-6.85 7.32-13.65 14.69-20.55 22.15 4.18 5.35 8.3 10.63 12.43 15.91 2.92 3.73 5.92 7.39 8.71 11.21.99 1.35 2.16 1.8 3.66 2.02 3.09.46 6.16 1 9.27 1.52v10.34h-2.17c-6.59 0-13.18-.04-19.77.03-1.23.01-1.95-.37-2.67-1.36-8.68-11.87-17.42-23.7-26.14-35.54-.36-.49-.75-.95-1.38-1.76v26.56l8.76 1.52c1.15.2 1.71.73 1.66 2.05-.11 2.79-.03 5.6-.03 8.51h-39.46c0-3.12-.04-6.17.06-9.22.01-.37.75-.95 1.22-1.04 3.07-.59 6.15-1.16 9.26-1.55 1.46-.18 2.06-.57 2.06-2.19-.05-27.64-.05-55.27-.01-82.91 0-1.45-.39-2.03-1.89-2.16-3.18-.26-6.34-.77-9.53-1.04-1.18-.1-1.72-.38-1.69-1.67.08-2.81.02-5.61.02-8.66 4.6-.41 9.09-.81 13.57-1.2 5.25.02 10.5.02 15.74.02zM29.18 2.74c.09.68.27 1.37.27 2.05.02 11.83.07 23.67-.02 35.5-.03 3.44-.46 6.87-.73 10.58.34-.45.57-.7.74-.98 5.37-9.21 15.65-14.11 26.33-12.83 11.78 1.41 19.26 7.96 22.41 19.09 3.54 12.51 3.22 25.1-1.8 37.22-5.37 12.96-15.53 20.03-29.25 21.79-11.01 1.41-21.94.17-32.74-2.26-1.19-.27-1.48-.85-1.48-1.98.04-6.33.02-12.67.02-19v-73.5c0-2.73.01-2.82-2.64-3.15-3.42-.43-6.86-.69-10.29-1.02V3.89c2.09-.15 4.18-.3 6.27-.47 2.65-.22 5.29-.46 7.94-.69 4.99.01 9.98.01 14.97.01zm-.15 84.96c.09 0 .19.01.28.01 0 3.96.04 7.93-.02 11.89-.02 1.18.39 1.68 1.54 1.95 4.65 1.11 9.38 1.39 14.09.86 8.04-.91 13.35-5.46 15.88-13.06 1-3 1.68-6.18 1.95-9.33.59-6.83.51-13.68-1.98-20.23-4.3-11.35-16.37-10.74-22.2-5.75-5.13 4.4-7.71 10.21-8.56 16.66-.73 5.61-.68 11.33-.98 17zM268.88 80.02c.08-9.44 1.38-16.82 4.96-23.64 7.61-14.49 21.67-20.72 37.06-19.2 3.83.38 7.74 1.22 11.33 2.57 8.57 3.23 14.01 9.68 16.73 18.3 3.2 10.11 3.47 20.4.62 30.62-4.89 17.55-19 27.77-37.39 27.35-6.55-.15-12.83-1.42-18.49-4.9-8.02-4.93-11.97-12.55-13.67-21.48-.7-3.76-.92-7.6-1.15-9.62zm16.81-3.23c.38 3.16.56 6.37 1.19 9.48 1.17 5.77 3.69 10.81 9.15 13.7 7.99 4.23 21.3 3.36 26.48-10.09 3.36-8.74 3.1-17.69.27-26.5-2.55-7.94-8.33-12.18-16.31-12.52-7.95-.34-14.38 3.62-17.74 10.95-2.18 4.75-2.88 9.78-3.04 14.98zM142.1 51.17h-14.47V38.35h14.44v-24.1c5.48-1.47 10.83-2.9 16.4-4.39V38.4h19.93v12.96h-19.53c-.06.72-.15 1.27-.15 1.82-.01 12.16-.03 24.31.02 36.47.01 1.78.19 3.58.51 5.33.84 4.52 3.12 6.59 7.71 6.73 2.79.09 5.6-.3 8.4-.5.75-.05 1.49-.2 2.46-.34.4 4.37.78 8.6 1.2 13.15-3.4.48-6.6 1.23-9.81 1.32-4.77.13-9.61.17-14.32-.46-6.93-.93-10.73-5.52-11.95-12.23-.51-2.82-.8-5.71-.81-8.57-.08-13.5-.04-27-.04-40.5.01-.74.01-1.49.01-2.41zM98.82 51.07c-4.45-.51-8.69-1-13.05-1.5V39.18c9.7-.36 19.39-.73 29.32-1.1v64.01c3.69.59 7.15 1.19 10.62 1.68 1.66.24 2.36.91 2.22 2.73-.19 2.54-.05 5.1-.05 7.82H85.66c0-3.03-.04-6.14.06-9.24.01-.36.79-.9 1.27-.99 3.33-.58 6.67-1.13 10.03-1.55 1.38-.17 1.95-.56 1.94-2.1-.06-15.8-.04-31.6-.04-47.4.01-.56-.05-1.13-.1-1.97z"
  }))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    className: "bitkom_svg__st16",
    d: "M92.53 19.97c7.04-1.15 14.08-2.3 21.12-3.46V0H92.53v19.97z"
  })));
}
/* harmony default export */ var bitkom = (SvgBitkom);
;// CONCATENATED MODULE: ./public/artifacts/icons/logo/c-and-a.svg
var c_and_a_style, c_and_a_g;
function c_and_a_extends() { return c_and_a_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, c_and_a_extends.apply(null, arguments); }

function SvgCAndA(props) {
  return /*#__PURE__*/react.createElement("svg", c_and_a_extends({
    id: "c-and-a_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 312.49 162.56",
    xmlSpace: "preserve"
  }, props), c_and_a_style || (c_and_a_style = /*#__PURE__*/react.createElement("style", null, ".c-and-a_svg__st16{fill:#565b58}")), c_and_a_g || (c_and_a_g = /*#__PURE__*/react.createElement("g", {
    id: "c-and-a_svg__xwpVdT_tif_00000110455208384094036250000012344077719216419257_"
  }, /*#__PURE__*/react.createElement("path", {
    className: "c-and-a_svg__st16",
    d: "M277.04 161.41c-10.25 0-20.49.01-30.74 0-4.11-.01-4.65-.55-4.66-4.57-.01-2 0-4 .02-6 .02-2.1.92-3.25 3.2-3.18 1.83.06 3.68.07 5.49-.15 3.74-.46 5.31-2.77 4.22-6.32-2.42-7.86-4.99-15.67-7.44-23.52-.54-1.74-1.84-1.67-3.18-1.67h-33.74c-4.58 0-9.17-.09-13.74.07-.92.03-2.32.79-2.64 1.56-3.14 7.6-6.21 15.23-9.05 22.95-1.32 3.58.1 5.89 3.86 6.56 2.6.46 5.3.39 7.96.5 2.76.11 3.44.71 3.48 3.39.04 2.41 0 4.83.01 7.25.01 1.82-.9 2.78-2.7 2.91-.66.05-1.33.08-2 .08-13.41 0-26.82.01-40.24 0-4.07 0-4.61-.56-4.63-4.61-.01-2-.04-4 .04-6 .07-1.96.98-3.09 3.13-3 1.41.06 2.84.03 4.24-.13 4.57-.53 7.42-3.08 9.19-7.35 12.49-30.09 25.1-60.13 37.65-90.19 6.15-14.72 12.27-29.45 18.38-44.18 1.76-4.25 2-4.45 6.63-4.46 4.91-.01 9.83.06 14.74-.02 2.43-.04 3.8.94 4.61 3.27 7.55 21.66 15.18 43.29 22.76 64.93 7.5 21.41 14.95 42.83 22.44 64.23.88 2.51 1.8 5.01 2.75 7.49 1.72 4.48 4.29 6.31 9.08 6.41 5.82.13 6.43-1.25 6.33 6.5-.09 7.2.75 7.3-7.2 7.26-9.42-.04-18.83-.01-28.25-.01zm-34.28-57.9c-6.18-20.41-12.23-40.41-18.29-60.41l-.88.09c-8.03 19.99-16.06 39.97-24.24 60.32h43.41zM123.27 23.79c0 6.08.01 12.16 0 18.25-.01 4.28-.4 4.65-4.79 4.66-1.75 0-3.5.03-5.25-.01-2.83-.06-3.43-.88-4.14-3.61-1.28-4.89-2.41-9.9-4.43-14.49-4.32-9.8-12.69-13.77-22.91-14.7-14.16-1.28-22.64 6.34-28.41 18.1-4.82 9.84-6.99 20.42-8.15 31.23-1.58 14.66-.77 29.3 1.13 43.86 1.43 11.02 3.97 21.82 10.83 30.98 5.33 7.12 12.45 10.73 21.44 10.77 6.09.03 12-.66 17.4-3.6 7.39-4.02 11.04-10.81 13.11-18.62.7-2.65 1.29-5.34 1.79-8.03.37-1.98 1.41-2.89 3.42-2.83 1.91.05 3.83 0 5.75.01 4.17.01 4.86.71 4.87 5 .01 7.83 0 15.66 0 23.49 0 4.33.03 8.66-.01 13-.03 3.29-.71 3.96-3.97 4.03-2 .04-4-.04-6 .03-2.05.07-3.68-.35-4.77-2.39-1.01-1.88-2.89-2.03-4.83-1.59-5.59 1.29-11.12 2.86-16.76 3.83-35.11 6.03-66.72-7.19-81.52-42.81C.34 102.13-1.2 85.23.88 67.88 2.56 53.85 6.77 40.76 14.87 29.1 24.2 15.67 36.76 6.8 52.62 2.58 64.53-.59 76.5-.81 88.46 1.88c4.01.9 7.85 2.68 11.68 4.27 4.4 1.82 6.64 1.11 9.16-2.85.64-1.01 2.1-1.91 3.29-2.07 2.46-.32 4.98-.14 7.48-.12 2.24.02 3.28 1.11 3.25 3.44-.1 6.41-.06 12.83-.05 19.24z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "c-and-a_svg__st16",
    d: "M149.09 72.46c2.81 4.2 5.46 8.17 8.3 12.43 2.86-3.46 4.61-7.01 5.7-10.84.65-2.26 1.68-3.37 4.18-3.25 3.66.18 7.33.09 11 .03 2.08-.03 2.52.95 1.84 2.68-.86 2.21-1.7 4.28-4.81 4.2-1.02-.03-2.33 1.13-3.07 2.09-2.89 3.75-5.55 7.68-8.43 11.43-1.02 1.33-.78 2.16.27 3.19 2.19 2.14 4.88 2.69 7.8 2.72 2.66.03 2.94.67 2.08 3.22-.86 2.55-2.27 3.63-5.12 3.54-4.76-.16-9.49.09-13.65-2.94-.5-.36-1.87.13-2.66.55-8.07 4.29-16.44 4.9-24.8 1.38-12.16-5.12-13.79-19.54-3.25-27.57 1.84-1.4 3.92-2.52 6-3.54 1.42-.69 1.97-1.22.99-2.77-6.55-10.33-.74-22.46 12.87-23.39 4.94-.34 9.67.16 13.63 3.56 5.16 4.44 5.62 11.68.96 16.61-1.3 1.38-2.83 2.59-4.41 3.66-1.57 1.07-3.32 1.86-5.42 3.01zM130.2 87.94c.2 4.12 1.4 7.75 5.46 9.61 4.29 1.96 8.24 1.05 11.84-1.9 1.26-1.03 1.2-1.93.31-3.14-3.44-4.68-6.86-9.38-10.22-14.13-1.01-1.42-1.91-1.35-3.01-.24-2.68 2.7-4.12 5.97-4.38 9.8zm14.4-21.36c5.07-2.63 7.53-7.68 6.03-11.99-.89-2.55-2.72-3.9-4.96-3.66-2.3.24-4.24 2.13-4.6 4.56-.64 4.22.79 7.79 3.53 11.09z"
  }))));
}
/* harmony default export */ var c_and_a = (SvgCAndA);
;// CONCATENATED MODULE: ./public/artifacts/icons/logo/celonis2.svg
var celonis2_style, celonis2_path, celonis2_g;
function celonis2_extends() { return celonis2_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, celonis2_extends.apply(null, arguments); }

function SvgCelonis2(props) {
  return /*#__PURE__*/react.createElement("svg", celonis2_extends({
    id: "celonis2_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 443.01 142.68",
    xmlSpace: "preserve"
  }, props), celonis2_style || (celonis2_style = /*#__PURE__*/react.createElement("style", null, ".celonis2_svg__st16{fill:#565b58}")), celonis2_path || (celonis2_path = /*#__PURE__*/react.createElement("path", {
    className: "celonis2_svg__st16",
    d: "M68.05 142.68c-30.65.09-55.27-15.48-64.16-40.6C-4.69 77.85.7 62.38 22.31 49.24c3.24-1.97 6.52-3.89 9.75-5.88 13.79-8.46 25.32-19.3 34.44-32.7C73.5.37 79.87-2.16 91.82 1.75c5.64 1.84 11.58 4.43 15.91 8.32 23.72 21.33 32.76 48.57 27.09 79.49-5.82 31.76-33.91 53.03-66.77 53.12zm26.78-72.35c-1.89-13.72-15.39-18.97-25.8-17.42-13.98 2.08-21.45 12.01-20.42 27.14.88 12.82 9.73 21.27 22.83 21.78 12.57.49 21.6-6.51 23.4-20.32-4.45 2.01-8.77 2.71-10.99 5.24-4.86 5.53-10.25 7.82-16.66 5.24-6.33-2.55-9.32-9.49-7.9-18.74 1.05-6.81 4.88-11.53 11.92-11.51 3.65.01 8.94 1.47 10.61 4.1 3.46 5.48 7.43 5.81 13.01 4.49z",
    id: "celonis2_svg__QPNPK7_tif_00000094619226935315803880000011259172307334269363_"
  })), celonis2_g || (celonis2_g = /*#__PURE__*/react.createElement("g", {
    id: "celonis2_svg__Bs3S93_tif"
  }, /*#__PURE__*/react.createElement("path", {
    className: "celonis2_svg__st16",
    d: "M262.85 82.23h-33.72c.01 1.69.24 3.3.69 4.86 1.47 5.11 5.84 8.39 11.17 8.5 2.86.06 5.51-.5 7.91-2.09 2.16-1.43 3.53-3.42 4.12-5.94.07-.31.16-.46.51-.46 2.97.01 5.95.01 8.92.01.09 0 .18.02.34.03-.13.57-.23 1.13-.39 1.67-1.69 5.74-5.25 9.89-10.76 12.22-6.1 2.58-12.32 2.71-18.52.34-5.53-2.11-9.29-6.07-11.29-11.58-2.17-5.98-2.25-12.1-.2-18.11 2.46-7.22 7.6-11.57 15.04-13.18 5.19-1.12 10.26-.67 15.14 1.44 5.07 2.19 8.4 6.02 10.23 11.19 1.21 3.43 1.44 6.95.95 10.54-.04.17-.1.34-.14.56zm-33.57-6.15h24.78c-.06-.53-.09-1.03-.19-1.52-.74-3.86-2.76-6.75-6.44-8.32-2.28-.98-4.68-1.26-7.15-1.01-4.43.45-9.13 3.25-10.51 8.69-.18.7-.32 1.41-.49 2.16zM288.23 80.09c0-4.36.71-8.19 2.59-11.76 2.71-5.16 6.94-8.49 12.5-10.11 5.44-1.58 10.87-1.43 16.18.59 5.97 2.28 10.02 6.5 12 12.55 1.93 5.88 1.83 11.82-.31 17.64-2.03 5.53-5.87 9.44-11.38 11.58-6.07 2.37-12.21 2.44-18.29.1-6.79-2.61-10.83-7.67-12.59-14.64-.54-2.06-.72-4.18-.7-5.95zm22.2-15.01c-.59.05-1.25.07-1.91.17-4.47.7-7.76 2.99-9.61 7.17-1.63 3.67-1.73 7.49-1.04 11.37.48 2.69 1.61 5.09 3.58 7.01 2.89 2.83 6.43 3.83 10.39 3.48 5.27-.46 9.26-3.69 10.85-8.73.85-2.71.97-5.49.7-8.29-.23-2.36-.9-4.6-2.21-6.6-2.53-3.83-6.22-5.43-10.75-5.58zM381.29 101.97c-.22.01-.41.03-.6.03-2.58 0-5.16-.01-7.74.02-.54.01-.69-.14-.69-.69.02-7.83.01-15.65.01-23.48 0-2.12-.13-4.22-.9-6.23-1.5-3.95-4.39-6.16-8.56-6.71-2.55-.34-5.05-.13-7.4 1-3.48 1.67-5.42 4.54-6.1 8.26-.28 1.56-.4 3.16-.41 4.75-.04 7.42-.02 14.83-.02 22.25v.78h-8.99V57.92h8.96v9.36l.12.03c.05-.09.12-.17.16-.27 2.36-5.78 6.79-8.89 12.86-9.7 3.5-.47 6.94-.1 10.17 1.46 4.15 2 6.7 5.37 8.07 9.69.76 2.39 1.06 4.86 1.07 7.35.03 8.56.01 17.12.01 25.69.01.12-.01.26-.02.44zM205.33 85.48h9.53c-.1.5-.17.96-.28 1.42-1.92 8.1-7.85 13.64-16.09 15-4.49.74-8.92.53-13.22-1.12-5.48-2.1-9.34-5.9-11.39-11.36-2.51-6.66-2.52-13.43.25-20.01 2.88-6.83 8.27-10.68 15.52-11.89 4.69-.79 9.34-.44 13.75 1.46 6.06 2.6 9.69 7.27 11.2 13.64.1.41.17.83.25 1.28h-9.55c-.1-.39-.18-.79-.3-1.17-1.38-4.32-4.4-6.74-8.81-7.49-2.44-.41-4.86-.31-7.17.68-3.13 1.33-5.37 3.58-6.47 6.79-1.63 4.78-1.63 9.62.16 14.36 1.72 4.53 6.03 7.34 10.88 7.33 2.64 0 5.13-.51 7.32-2.04 2.24-1.57 3.64-3.7 4.26-6.36.03-.12.05-.24.09-.37.02-.04.05-.09.07-.15zM408.39 87.87h8.65c.11.49.19 1 .34 1.49 1.1 3.48 3.59 5.42 7.04 6.21 2.03.46 4.08.56 6.1-.09 3.82-1.23 4.95-5.13 3.73-7.96-.54-1.27-1.59-2.05-2.73-2.72-1.62-.96-3.44-1.39-5.25-1.83-3.33-.8-6.69-1.52-9.92-2.7-3.21-1.18-5.86-3.09-6.92-6.47-1.97-6.29.41-12.56 7.26-15.27 3-1.19 6.14-1.43 9.34-1.25 2.19.12 4.34.46 6.38 1.28 5.16 2.07 8.3 5.92 9.73 11.23.16.6.26 1.21.4 1.87-.26.01-.44.03-.61.03-2.42 0-4.84-.01-7.25.02-.45 0-.65-.12-.75-.58-.86-4.23-4.06-6.99-8.38-7.32-1.66-.13-3.29-.04-4.86.56-2.19.84-3.53 2.83-3.62 5.17-.07 1.94.72 3.36 2.27 4.46 1.5 1.06 3.22 1.55 4.94 2.02 2.77.75 5.57 1.41 8.34 2.18 1.91.53 3.8 1.16 5.47 2.29 2.86 1.94 4.56 4.53 4.86 8.05.33 3.88-.65 7.23-3.55 9.91-2.08 1.93-4.59 3.05-7.36 3.51-4.5.74-8.97.56-13.27-1.05-5.97-2.24-9.4-6.6-10.41-12.88 0-.05.02-.09.03-.16zM280.48 101.74h-8.95V42.72h8.95v59.02zM399.86 101.74h-8.93c-.01-.22-.04-.43-.04-.64 0-14.2 0-28.4-.01-42.6 0-.55.15-.69.69-.68 2.56.03 5.12.01 7.68.02h.61v43.9zM395.35 39.55c2.28.16 4.18.91 5.26 2.97 1.51 2.86.4 6.8-3.98 7.55-1.59.27-3.14.11-4.57-.72-1.94-1.13-2.64-2.87-2.43-5.04.2-2.04 1.35-3.39 3.19-4.14.8-.33 1.69-.42 2.53-.62z"
  }))));
}
/* harmony default export */ var celonis2 = (SvgCelonis2);
;// CONCATENATED MODULE: ./public/artifacts/icons/logo/cosmoconsult.svg
var cosmoconsult_style, cosmoconsult_path;
function cosmoconsult_extends() { return cosmoconsult_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, cosmoconsult_extends.apply(null, arguments); }

function SvgCosmoconsult(props) {
  return /*#__PURE__*/react.createElement("svg", cosmoconsult_extends({
    id: "cosmoconsult_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 850.52 262.99",
    xmlSpace: "preserve"
  }, props), cosmoconsult_style || (cosmoconsult_style = /*#__PURE__*/react.createElement("style", null, ".cosmoconsult_svg__st0{fill:#737373}")), cosmoconsult_path || (cosmoconsult_path = /*#__PURE__*/react.createElement("path", {
    className: "cosmoconsult_svg__st0",
    d: "M145.45 236.62c-33.88 0-67.75.09-101.63-.03-25.3-.09-44.8-20.6-43.79-45.87.32-7.95 2.71-15.34 7.2-21.92 34.18-50.08 68.2-100.27 102.69-150.13 17.61-25.46 54.32-24.68 72.13 1.15 22.2 32.18 44.16 64.53 66.21 96.82 11.83 17.31 23.86 34.48 35.42 51.97 15.08 22.83 6.35 53.28-18.53 64.03-5.8 2.5-12.58 3.75-18.92 3.82-33.59.35-67.18.16-100.78.16zm-52.76-15.5c3.62-.63 7.28-1.06 10.84-1.93 15.39-3.77 30.75-7.67 46.13-11.51 22.65-5.66 45.35-11.19 67.95-17.03 13.61-3.52 22.55-12.28 25.94-25.96 3.26-13.18-.16-25.01-10.18-34.07-26.8-24.24-53.76-48.31-81.02-72.04-18.01-15.67-46.6-8.72-55.16 13.54-13.05 33.93-25.64 68.05-37.84 102.31-8.11 22.73 9.18 46.27 33.34 46.69zM795.48 159.47c-32.11-.13-54.52-22.47-54.43-54.24.09-31.58 23.25-54.24 55.28-54.08 31.98.16 54.29 22.59 54.2 54.49-.1 31.32-23.25 53.96-55.05 53.83zm.7-89.86c-19.82-.26-34.12 14.4-34.38 35.23-.25 20.19 14.47 36.08 33.69 36.35 19.97.28 34.1-14.13 34.47-35.16.36-20.77-13.9-36.15-33.78-36.42zM464.06 159.47c-32.18-.09-54.37-22.22-54.35-54.19.02-31.69 23-54.27 55.08-54.13 32.03.14 54.26 22.48 54.17 54.43-.09 31.44-23.05 53.98-54.9 53.89zm.04-89.86c-19.76.08-33.85 15.01-33.8 35.83.05 20.15 15.14 35.87 34.31 35.75 20.21-.13 33.91-14.79 33.8-36.18-.11-20.65-14.48-35.48-34.31-35.4zM565.63 159.48c-11.04-.45-21.49-2.96-29.9-10.91-4.5-4.25-4.5-6-.64-10.7.54-.66 1.08-1.32 1.62-1.97 5.09-6.06 5.03-5.97 11.41-1.24 6.87 5.09 14.46 7.73 23.11 5.84 4.6-1.01 8.05-3.47 9.21-8.32 1.16-4.82-.54-8.89-4.35-11.61-3.88-2.78-8.23-4.91-12.46-7.18-5.35-2.87-11.01-5.25-16.14-8.46-11.04-6.89-15.44-17.24-13.16-29.88 2.17-12.08 10.17-19.42 21.79-22.44 12.8-3.32 25.03-1.5 36.17 5.89 4.47 2.97 4.64 4.7 1.59 9.06-.41.58-.81 1.16-1.22 1.74-5.11 7.13-5.12 7.14-12.83 2.94-5.38-2.93-11.15-3.38-16.92-2.03-8.64 2.01-11.56 11.37-5.43 17.84 2.64 2.79 6.27 4.8 9.74 6.62 6 3.15 12.44 5.52 18.32 8.86 13.62 7.74 19.12 21.2 14.3 34.89-4.63 13.16-15.11 18.78-28.13 20.7-1.96.3-3.96.25-6.08.36zM370.62 159.45c-32.39-.05-54.16-22.4-53.6-55.01.48-27.36 15.32-46.66 40.46-51.95 13.98-2.94 27.63-1.8 40.24 5.67 4.67 2.77 5.01 4.54 2.19 9.31-.65 1.1-1.3 2.19-1.96 3.28-2.85 4.63-4.32 5.05-9.38 2.68-16.11-7.54-34.12-4.13-43.69 8.09-12.4 15.85-11.23 51.36 18.84 58.58 9.93 2.38 19.38.8 28.35-3.96 5.21-2.76 6.09-2.47 8.8 2.81 4.65 9.04 4.15 10.52-5.17 15.08-7.3 3.57-15.91 5.43-25.08 5.42zM637.76 86.67v35.62c0 9.78.02 19.55-.01 29.33-.02 5.18-1.04 6.16-6.25 6.23-2.41.03-4.82.03-7.22 0-5.23-.07-6.06-.91-6.07-6.31-.02-18.13-.01-36.27-.01-54.4 0-12.75-.01-25.5.01-38.25.01-5.2.83-6.15 5.82-6.06 17.72.32 12.22-2.75 22.32 11.68 11.2 16.01 22.04 32.27 33.22 48.29 2.3 3.3 2.67 5.91-.06 9-1.59 1.79-2.72 3.96-4.14 5.91-2.8 3.83-5.63 3.84-8.37-.13-8.61-12.47-17.14-24.99-25.7-37.48-.86-1.25-1.77-2.48-2.66-3.71-.3.09-.59.19-.88.28zM704.09 85.88c-3.78 5.54-7.56 11.09-11.36 16.63-3.6 5.25-4.97 5.3-8.47.06-7.7-11.53-8.27-8.56.02-20.74 5.73-8.42 11.59-16.76 17.19-25.27 1.86-2.83 4.1-4 7.4-3.8 3.1.19 6.23.02 9.34.04 5.08.03 6.16 1.08 6.16 6.28.03 19.26.01 38.51.01 57.77 0 11.33.01 22.65 0 33.98-.01 6.25-.79 7-7.17 7.02-2.27.01-4.53-.07-6.8.01-3.97.14-5.52-1.7-5.5-5.66.1-18.41.04-36.81.04-55.22V86.15c-.27-.08-.56-.18-.86-.27zM290.12 39.79c-.09 14.52-11.73 26-26.31 25.95-14.49-.05-26.16-11.75-26.14-26.21.02-14.43 11.78-26.2 26.19-26.23 14.67-.03 26.35 11.75 26.26 26.49zM596.22 251.91v-5.06-47.61c0-.99-.12-2 .02-2.97.3-2.11-1.28-5.47 2.7-5.43 3.68.04 2.39 3.22 2.45 5.2.15 5.1.05 10.2.05 15.3 0 15.3.05 30.61-.08 45.91-.01 1.58-1.06 3.14-1.63 4.71-1.61-.88-3.7-1.37-4.76-2.68-14.48-17.99-28.82-36.09-43.19-54.16-.79-.99-1.61-1.97-3.15-3.85-.11 2.28-.23 3.68-.23 5.08-.01 16.58-.01 33.16-.01 49.74 0 .99.33 2.17-.09 2.93-.63 1.15-1.79 2-2.72 2.98-.85-.91-1.89-1.73-2.5-2.78-.37-.64-.1-1.66-.1-2.51 0-20.26-.04-40.53.08-60.79.01-1.72 1.13-3.42 1.73-5.14 1.69.98 3.86 1.59 5.01 3.01 14.28 17.78 28.41 35.69 42.59 53.55 1.01 1.29 2.1 2.52 3.83 4.57zM460.96 226.38c0-20.76 15.34-36.49 35.61-36.52 20.52-.04 35.89 15.74 35.79 36.76-.1 20.69-15.58 36.36-35.87 36.3-20.36-.05-35.54-15.66-35.53-36.54zm65.47.4c.14-17.84-12.69-31.55-29.66-31.66-16.86-.11-29.78 13.24-29.89 30.91-.11 17.91 12.66 31.56 29.63 31.66 16.88.1 29.78-13.22 29.92-30.91zM732.33 216.18c0 6.66.24 13.32-.05 19.97-.69 16.01-10.97 26.41-26.11 26.7-16.16.32-28.19-9.92-29.02-25.86-.75-14.27-.39-28.6-.3-42.9.01-1.12 1.74-2.23 2.67-3.34.89 1.14 2.53 2.27 2.55 3.43.19 11.75-.01 23.51.19 35.26.07 3.92.52 7.95 1.55 11.72 3.02 11.01 12.16 17.25 23.24 16.33 10.92-.9 18.31-7.87 19.19-19.61.84-11.27.55-22.63.73-33.95.05-3.26-.23-6.54.14-9.76.14-1.22 1.67-2.29 2.57-3.43.93 1.11 2.62 2.2 2.66 3.34.24 7.36.12 14.73.12 22.09-.04.01-.09.01-.13.01zM619.87 249.6c1.14.94 2.28 2 3.53 2.9 6.86 4.93 14.27 6.66 22.45 3.75 4.91-1.75 8.29-4.94 8.97-10.28.7-5.42-1.32-9.9-6.02-12.65-4-2.35-8.38-4.05-12.58-6.07-3.31-1.59-6.75-2.98-9.87-4.88-6.34-3.84-8.91-9.72-8-17 .87-7.01 4.95-11.65 11.52-13.9 8.84-3.03 17.31-1.88 25.2 3.11 1.51.95 3.33 2 1.69 4.36-1.63 2.34-3.08.96-4.64-.06-5.66-3.7-11.85-4.51-18.33-3.01-4.75 1.1-8.31 3.85-9.37 8.79-1.12 5.25.04 10.2 4.81 13.08 4.56 2.76 9.68 4.59 14.49 6.94 3.55 1.73 7.33 3.23 10.43 5.58 9.37 7.11 8.93 21.25-.62 28.13-9.5 6.85-25.92 5.77-34.41-2.27-3.13-2.98-3.07-3.7.75-6.52zM396.87 227.05c.06-26.74 21.63-42.93 46.47-35.55 1.75.52 3.58 1.08 5.09 2.06 1.67 1.08 5.13 1.36 3.73 4.56-1.67 3.82-4.04.79-5.9-.04-18.61-8.22-42.6.4-43.42 27.19-.36 11.62 3.27 21.7 13.69 27.9 10.56 6.28 21.52 6.02 32.36.2 1.43-.77 2.96-2.89 4.6-.24 1.65 2.66-.7 3.57-2.24 4.56-16.96 10.97-50.13 6.03-54.03-25.41-.26-1.96-.27-3.95-.35-5.23zM813.78 196.05h-19.57c-1.28 0-2.69.34-3.79-.11-1.14-.47-1.97-1.71-2.93-2.61 1.02-.86 2.04-2.47 3.07-2.48 17.29-.16 34.58-.16 51.86 0 1.04.01 2.07 1.59 3.11 2.44-1.09.92-2.17 2.6-3.29 2.63-7.47.24-14.96.12-22.81.12-.09 1.94-.21 3.45-.21 4.95-.01 18.14-.01 36.28-.01 54.42 0 .99-.03 1.99 0 2.98.07 2.05-.35 4.08-2.86 3.48-1.07-.26-2.42-2.2-2.45-3.41-.22-7.93-.12-15.87-.12-23.8v-38.61zM757.72 256.79h25.03c3.25 0 6.53-.18 9.75.14.96.09 1.79 1.58 2.68 2.43-.86.89-1.63 1.91-2.62 2.61-.47.34-1.37.07-2.08.07-11.18 0-22.36-.11-33.54.07-3.6.06-5.02-.91-4.99-4.75.15-20.66.07-41.32.08-61.99 0-2.09-.43-4.59 2.84-4.6 3.26-.01 2.85 2.48 2.85 4.58.01 18.82.01 37.64.01 56.47-.01 1.51-.01 3.02-.01 4.97z"
  })));
}
/* harmony default export */ var cosmoconsult = (SvgCosmoconsult);
;// CONCATENATED MODULE: ./public/artifacts/icons/logo/docotlib.svg
var docotlib_style, docotlib_path, _path2;
function docotlib_extends() { return docotlib_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, docotlib_extends.apply(null, arguments); }

function SvgDocotlib(props) {
  return /*#__PURE__*/react.createElement("svg", docotlib_extends({
    id: "docotlib_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 826.17 244.94",
    xmlSpace: "preserve"
  }, props), docotlib_style || (docotlib_style = /*#__PURE__*/react.createElement("style", null, ".docotlib_svg__st0{fill:#737373}")), docotlib_path || (docotlib_path = /*#__PURE__*/react.createElement("path", {
    className: "docotlib_svg__st0",
    d: "M513.27 195.28c-2.72 3.37-5.29 6.63-7.95 9.82-6.25 7.49-14.24 9.18-23.54 7.44-13.78-2.57-22.65-11.44-29.85-22.57-1.34-2.08-2.46-4.3-3.58-6.3-2.96 3.94-5.69 8.11-8.95 11.82-8.22 9.36-18.27 15.67-30.87 17.3-13.9 1.8-25.69-2.79-35.84-12.07-7.24-6.62-12.65-14.59-16.74-23.79-.61.67-1.14 1.21-1.63 1.79-4.8 5.61-10.71 9.28-18.13 10.17-3.35.4-5.23 2.41-6.43 5.26-6.7 15.85-28.47 20.96-39.98 17.7-4.9-1.39-9.13-3.98-12.77-7.42-6.17-5.82-12.33-11.83-13.34-20.85-1.34-11.97 1.59-23.06 7.78-33.34 3.31-5.49 7.58-10.09 13.01-13.5 7.95-4.99 16.32-5.86 24.75-1.42 2.24 1.18 4.19 3.26 5.72 5.33 1.04 1.42 1.91 2.4 3.66 2.94 11.13 3.41 17.18 11.35 19.57 22.43.24 1.12.42 2.26.62 3.35 3.63 1.56 11.32-2.62 14.09-6.41.41-.56.28-1.53.38-2.31.49-3.6.65-7.28 1.53-10.78 2.99-11.96 13.24-20.87 26.56-21.7 10.46-.65 20.57 1.08 29.95 5.85 11.06 5.63 15.35 16.1 11.61 27.46-1.5 4.54-3.32 5.15-7.14 2.15-2.72-2.13-5.24-4.53-7.92-6.72-1.44-1.18-2.95-2.3-4.55-3.24-5.92-3.49-11.88-1.95-14.7 4.34-3.76 8.37-5.05 17.26-2.6 26.25 3.92 14.37 21.62 19.6 32.95 9.89 5.24-4.49 8.67-10.3 11.43-16.5 6.43-14.45 10.02-29.68 12.24-45.29 1.07-7.54 2.42-15.05 3.68-22.75-4.45-.25-8.93-.32-13.37-.81-2.78-.31-5.59-1.01-8.18-2.05-1.06-.43-2.22-2.24-2.18-3.38.07-1.82 1.44-2.95 3.64-3.09 6.82-.42 13.62-1.17 20.45-1.52 2.31-.12 2.43-1.52 2.83-3.06 2.87-11.16 5.61-22.36 8.67-33.46 2.25-8.16 6.32-10.23 14.31-7.45 5.26 1.83 10.46 3.9 15.51 6.24 2.1.97 3.93 2.75 5.53 4.49 2.55 2.77 3.38 6.09 2.38 9.88-1.36 5.14-2.51 10.34-3.75 15.51-.12.52-.23 1.03-.44 1.97 4.68-.63 9.18-1.37 13.71-1.8 6.33-.6 12.77-1.81 19.02-1.24 8.62.78 16.65 4.15 23.86 9.14.87.6 1.9 1.19 2.42 2.05.82 1.35 1.78 2.97 1.68 4.4-.05.72-2.29 1.72-3.6 1.83-7.87.65-15.75 1.23-23.64 1.54-11.71.46-23.43.68-35.15 1.01-.7.02-1.41.09-2.39.16-1.4 5.82-2.82 11.65-4.19 17.49-4.25 18.13-8.54 36.25-12.65 54.41-.7 3.08-.89 6.34-.9 9.51-.01 6.87 6.29 11.84 12.87 9.81 3.09-.96 6.3-2.79 8.5-5.12 3.36-3.57 6.3-7.69 8.68-11.98 2.61-4.71 4.14-9.99 6.55-14.83 3.58-7.2 7.13-14.47 11.41-21.25 4.66-7.37 11.18-12.86 20.02-14.84 5.75-1.28 11.36-.76 16.46 2.33 1.92 1.16 3.85 2.74 4.99 4.6 1.25 2.05 2.7 3.11 4.91 3.84 11.36 3.73 16.96 12.27 18.93 23.55.36 2.05 1.07 2.49 2.9 2.21 4.31-.66 7.84-2.75 10.78-5.85.48-.51.62-1.61.51-2.38-4.61-32.81-6.17-65.76-4.37-98.84.55-10.1 1.54-20.19 4.54-29.94 4.29-13.9 11.91-20.32 26.34-20.97 6.01-.27 12.3.54 18.11 2.14 10.9 2.99 16.46 11.02 18.11 22.02 1.19 7.93-.6 15.55-2.17 23.19-6.33 30.77-17.04 59.82-34.13 86.34-1.25 1.94-2.4 3.98-3.88 5.73-5.91 6.99-6.13 15.24-5.36 23.68.51 5.51 2.26 10.58 6.31 14.6 5.17 5.14 10.07 5.5 15.88 1.11 5.43-4.09 9.4-9.5 12.54-15.38 3.5-6.55 6.57-13.35 9.39-20.22 1.18-2.88 1.27-6.2 1.84-9.33.72-3.87 2.24-4.94 5.91-3.77 4.13 1.32 8.25 2.73 12.26 4.38 7.36 3.03 11.86 8.28 12.92 16.46.92 7.12 2.34 14.18 3.65 21.24 1.43 7.73 4.28 8.87 10.55 4.11 6.37-4.83 11.39-10.94 15.35-17.85.82-1.43 1.03-3.58.69-5.23-5.86-28.9-7.56-58.05-5.48-87.44 1-14.18 2.5-28.3 7.13-41.86 1.2-3.51 2.59-7 4.25-10.32 6.27-12.54 13.8-16.45 27.62-14.4 8.04 1.2 15.63 3.79 22.93 7.42 9.73 4.84 14.32 12.75 15.03 23.35.85 12.66-1.25 24.99-4.34 37.13-7.44 29.2-17.75 57.33-34.31 82.67-4.12 6.31-3.86 12.16-2.8 18.6.56 3.39 1.49 6.77 2.66 10 .67 1.84 1.93 3.63 3.34 5 2.3 2.23 4.63 1.86 6.56-.7 3.47-4.6 4.84-10 5.89-15.53.13-.7.22-1.4.37-2.1.61-2.84.39-5.28-1.42-7.92-1.67-2.45-2.78-5.62-3.11-8.59-.76-6.73 4.39-11.86 11.2-11.34 13.36 1.02 23.03 7.42 24.58 22.1.07.66.99 1.62 1.68 1.78 7.1 1.7 13.08 1.14 17.09-5.83 1.09-1.89 2.95-3.27 5.47-3.17-.79 9.44-14.67 19.16-27.48 19.33 1.55 7.54-1.73 13.61-6.17 19.15-4.6 5.75-10.72 8.97-18.12 9.4-10.52.62-19.53-3.41-27.34-9.97-4.86-4.09-9.06-8.97-13.55-13.5-.54-.55-1.02-1.16-1.52-1.74-1.84 3.6-3.37 7.18-5.4 10.45-4.9 7.89-11.55 13.38-21.17 14.5-7.35.86-13.62-1.61-19.24-6.09-5.99-4.77-10.46-10.83-14.34-17.36-.99-1.67-1.93-3.38-3.13-5.48-.53.97-.92 1.67-1.3 2.38-4.79 8.91-10.95 16.59-19.77 21.83-5.86 3.48-12.25 5.29-19.07 4.81-5.9-.42-10.49-3.69-14.41-7.84-6.5-6.9-11.18-14.85-13.39-24.16-.14-.57-.35-1.13-.5-1.59-2.53 2.21-4.74 4.79-7.51 6.37-3.4 1.94-7.17 3.54-10.99 4.38-3.48.77-5.86 2.2-7.22 5.44-6.71 15.94-28.84 21.29-40.72 17.54-6.65-2.09-11.77-6.44-16.36-11.49-1.46-1.56-2.8-3.21-4.22-4.87zm234.36-56.55c.27.08.54.16.81.25 2.15-4.64 4.43-9.22 6.42-13.93 6.36-15.09 10.18-30.96 14.07-46.79 2.95-12.01 5.27-24.14 4.03-36.58-.35-3.55-1.13-7.28-2.68-10.46-3.14-6.39-10.73-6.44-14.47-.4a29.88 29.88 0 00-1.95 3.77c-3.07 7.01-4.09 14.5-4.77 22-2.46 26.92-2.25 53.9-1.55 80.89 0 .42.06.84.09 1.25zm-126.98-7.4c.35.04.7.07 1.04.11.71-1.42 1.44-2.83 2.14-4.26 5.79-11.86 9.67-24.36 12.55-37.2 3.15-14.02 6.72-27.96 6.76-42.47.02-5.7-.14-11.38-2.36-16.75-1.36-3.28-3.73-5.45-7.44-5.53-3.44-.08-5.52 2.24-6.47 5.08-1.81 5.43-3.8 10.94-4.54 16.57-1.31 10.02-2.33 20.14-2.43 30.23-.16 18.07.46 36.15.75 54.22zM317.74 184.6c-11.01-7.71-18.07-18.05-22.46-30.81-4.79 8.36-8.11 16.68-9.43 25.75-.75 5.16-.87 10.28 1.29 15.17 3.01 6.82 7.3 8.34 13.92 4.97 6.8-3.48 11.98-8.76 16.68-15.08zm222.7-30.31c-.31.15-.54.19-.61.31-5.9 10.52-10.04 21.54-9.32 33.86.23 3.91 1.57 7.36 4.28 10.35 2.27 2.5 4.88 3.24 7.91 2.18 8.64-3.02 14.63-9.26 20.03-16.39-11.05-7.72-18.05-18.01-22.29-30.31zm249.99 16.13c.38-.38.75-.77 1.13-1.15-2.93-3.34-5.8-6.75-8.85-9.97-.5-.53-1.84-.27-2.79-.38.22.86.16 2 .71 2.53 3.18 3.06 6.51 5.99 9.8 8.97zM84.73 21.44c-.23-.79-.43-1.46-.66-2.24.45-.31.85-.65 1.31-.87 11.69-5.7 24-9.66 36.62-12.68 19.63-4.7 39.5-6.88 59.69-4.96 22.44 2.13 42.98 8.98 60.07 24.34 15.47 13.9 23.42 31.6 26.05 51.87 3.22 24.86-1.61 48.8-9.29 72.25-4.59 14-9.91 27.78-18.16 40.12-16.39 24.5-39.22 40.16-67.48 47.99-26.21 7.26-52.9 9.32-79.93 6.39-28.33-3.07-53.31-13.6-73.63-34.03-8.97-9.02-15.93-19.38-18.43-32.09-2.97-15.13 1.75-28.58 10.09-40.95 4.8-7.12 11.21-12.55 19.06-16.16.66-.31 1.56-.1 2.35-.12-.04.77.15 1.66-.17 2.31-6.12 12.51-9.22 25.6-8.52 39.62.5 9.95 5.45 17.4 12.28 23.98 8.45 8.14 18.37 14.2 28.57 19.83 16.34 9.02 33.14 16.97 51.26 21.83 18.68 5.01 37.35 5.53 55.88-.51 24.23-7.9 39.98-24.56 48.68-48.18 5.14-13.95 7.75-28.56 10.64-43.07 2.64-13.28 3.86-26.71 3.16-40.25-.73-14.23-3.89-27.7-12.39-39.55-6.3-8.77-14.79-14.71-24.29-19.39-12.87-6.35-26.69-9.47-40.74-11.71-19.26-3.07-38.68-3.76-58.14-3.76-4.61-.01-9.23-.01-13.88-.01z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "docotlib_svg__st0",
    d: "M127.75 177.23c-3.3-.04-4.32-1.59-3.63-5.16 1.39-7.13 2.78-14.27 4.19-21.4 5.81-29.48 11.61-58.95 17.43-88.43.19-.95.29-2.02.8-2.79 4.85-7.29 11.63-11.84 20.23-13.36 3.04-.54 4.48 1.61 3.82 5.03-1.92 9.92-3.87 19.83-5.82 29.74-5.25 26.69-10.49 53.39-15.81 80.07-.32 1.6-.9 3.34-1.9 4.59-4.48 5.65-10.36 9.33-17.24 11.41-.75.24-1.57.24-2.07.3zM676.2 117.95c-7.67-.05-13.94-6.68-13.83-14.63.11-8.07 6.34-14.41 14.1-14.34 7.78.07 13.91 6.54 13.82 14.6-.1 8.03-6.36 14.42-14.09 14.37z"
  })));
}
/* harmony default export */ var docotlib = (SvgDocotlib);
;// CONCATENATED MODULE: ./public/artifacts/icons/logo/helloFresh.svg
var helloFresh_style, helloFresh_g;
function helloFresh_extends() { return helloFresh_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, helloFresh_extends.apply(null, arguments); }

function SvgHelloFresh(props) {
  return /*#__PURE__*/react.createElement("svg", helloFresh_extends({
    id: "helloFresh_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 245.3 117.93",
    xmlSpace: "preserve"
  }, props), helloFresh_style || (helloFresh_style = /*#__PURE__*/react.createElement("style", null, ".helloFresh_svg__st16{fill:#565b58}")), helloFresh_g || (helloFresh_g = /*#__PURE__*/react.createElement("g", {
    id: "helloFresh_svg___x38_pDVV8_tif"
  }, /*#__PURE__*/react.createElement("path", {
    className: "helloFresh_svg__st16",
    d: "M245.3 29.59c-.07.45-.17.89-.19 1.34-.6 10.29-5.43 17.87-14.58 22.66-5.51 2.88-11.43 3.73-17.57 3.39-6.04-.33-11.58-2.15-16.51-5.66-5.74-4.1-9.11-9.74-10.36-16.64-.89-4.86-.8-9.73.48-14.51 2.07-7.74 6.79-13.34 13.96-16.9C205.96.58 211.72-.26 217.72.06c5.56.29 10.71 1.86 15.38 4.86 6.69 4.29 10.49 10.48 11.75 18.28.15.93.15 1.89.24 2.83.05.48.13.96.2 1.45.01.71.01 1.41.01 2.11zm-44.44-1.09c.12 1.19.16 2.39.38 3.55 1.01 5.36 3.97 9.13 9.22 10.92 2.37.81 4.82.97 7.28.57 5.68-.91 9.55-4.04 11.34-9.54 1.14-3.49 1.14-7.07.13-10.59-1.32-4.6-4.27-7.74-8.79-9.38-2.15-.78-4.39-.94-6.65-.71-4.88.5-8.62 2.79-11 7.14-1.36 2.5-1.84 5.22-1.91 8.04zM43.58 116.96V62.79c.36-.02.67-.06.98-.06 8.12 0 16.23-.03 24.35.03 4.08.03 8.04.77 11.73 2.59 4.54 2.23 7.76 5.62 9.14 10.58.73 2.62.81 5.28.27 7.93-.68 3.31-2.46 5.93-5.18 7.92-1.8 1.31-3.77 2.3-5.85 3.1-.26.1-.53.19-.79.3-.06.02-.09.1-.22.24 2.46 5 6.3 8.09 12.06 8.52v13.65c-.68 0-1.33.04-1.98-.01-10.91-.73-18.63-6.34-23.88-15.68-.68-1.22-1.25-2.5-1.89-3.79h-2.97c-.1 1.03-.03 2.07-.05 3.11-.01 1.05 0 2.11 0 3.16V116.96H43.58zm15.79-29.44c2.76 0 5.43.12 8.08-.04 2.23-.14 4.2-1.11 5.7-2.84 1.95-2.23 2.02-5.43.17-7.74-1.21-1.52-2.8-2.49-4.68-2.83-3.05-.56-6.14-.35-9.28-.18.01 4.51.01 9.02.01 13.63zM.09 1.4h15.73v22.52c3.07.62 14.83-1.56 19.3-3.5V1.54c.86-.23 13.6-.31 15.62-.12.22.72.29 52.7.07 54.16H35.14V32.59c-6.3 2.16-12.62 3.37-19.25 3.62-.09 2.16-.03 4.29-.04 6.41-.01 2.14 0 4.29 0 6.43v6.39c-.86.26-14.72.29-15.76.05V1.4zM244.14 116.82h-15.71V93.85c-6.33 2.2-12.68 3.37-19.35 3.66-.02 2.18-.01 4.31-.01 6.44v12.89h-15.73V62.72h15.7v22.54c.35.05.62.12.88.11 6.15-.27 12.11-1.5 17.95-3.41.16-.05.31-.14.55-.24v-19h15.71c.01 18.03.01 36.03.01 54.1zM139.46 105.36c4.08-2.16 8.13-4.31 12.26-6.5.11.26.2.44.25.62.82 2.76 2.59 4.74 5.16 5.94 3.7 1.73 7.57 1.99 11.51.92 1.06-.29 2.02-.8 2.88-1.49 2.18-1.75 2.2-5.11-.37-6.69-1.4-.86-2.91-1.4-4.49-1.74-3.33-.73-6.67-1.37-9.98-2.15-1.98-.46-3.94-1.04-5.86-1.69-2.87-.96-5.22-2.71-7.18-4.99-1.66-1.95-2.39-4.28-2.62-6.77-.21-2.25-.12-4.49.46-6.69 1.36-5.17 4.62-8.74 9.39-10.98 3.53-1.66 7.29-2.28 11.15-2.32 4.22-.04 8.33.58 12.23 2.29 3.62 1.6 6.64 3.92 8.78 7.3.35.56.64 1.15 1.01 1.83-3.79 2.01-7.5 3.97-11.21 5.94-.12-.18-.2-.26-.23-.35-.87-3.03-2.97-4.78-5.93-5.56-2.25-.59-4.52-.59-6.76.09-.99.3-1.86.81-2.57 1.59-1.65 1.83-1.39 4.55.59 6.01a8.27 8.27 0 003.23 1.48c3.02.65 6.06 1.22 9.06 1.91 2.7.62 5.39 1.3 8.05 2.08 2.9.86 5.28 2.57 7.29 4.83 1.55 1.74 2.37 3.81 2.68 6.08.57 4.11.14 8.06-2.07 11.68-1.81 2.96-4.38 5.1-7.43 6.68-3.42 1.77-7.07 2.69-10.89 3.03-4.69.42-9.34.16-13.89-1.13-4.22-1.2-8.03-3.15-11.12-6.34-1.38-1.42-2.53-2.99-3.38-4.91zM72.86 13.48v9.33c3.36.06 6.68.02 10.01.03 3.34.01 6.67 0 10.16 0 .02 3.45.01 6.84.01 10.35H73.02c-.24.9-.29 8.95-.08 10.28h23.72c.25.84.34 10.13.14 12.05-.74.21-37.2.3-38.93.09-.21-.74-.28-52.67-.06-54.17h39.14c.22.75.3 10.12.08 11.99-1.57.09-3.17.03-4.77.04-1.62.01-3.23 0-4.85 0h-9.59c-1.62.01-3.23.01-4.96.01zM96.65 62.7h38.24v11.98h-23.02c-.28.81-.37 7.32-.14 9.32.38.02.78.07 1.18.07h18.89v10.41h-20.09v10.22c2.01.07 3.99.02 5.98.03 2 .01 4 0 6.01 0H135.64v11.99c-.74.22-37.3.31-38.93.1-.21-.76-.28-52.52-.06-54.12zM15.96 75.95c-.24.91-.26 9.55-.04 10.69h17.49c.24.85.3 9.96.09 11.42H15.84c-.03.5-.07.91-.07 1.31v17.42H.21c-.22-.78-.29-52.52-.07-53.98h38.03v13.14H15.96zM103.29 55.64V1.42h15.75V42.3c.46.03.86.08 1.26.08H140.56v13.19c-2.49.15-4.97.05-7.44.07-2.49.02-4.99 0-7.48 0h-22.35zM146.24 1.4h15.72v40.98h21.52v13.19h-37.24V1.4z"
  }))));
}
/* harmony default export */ var helloFresh = (SvgHelloFresh);
;// CONCATENATED MODULE: ./public/artifacts/icons/logo/sumup.svg
var sumup_style, sumup_path, sumup_path2;
function sumup_extends() { return sumup_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, sumup_extends.apply(null, arguments); }

function SvgSumup(props) {
  return /*#__PURE__*/react.createElement("svg", sumup_extends({
    id: "sumup_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 762.82 221.25",
    xmlSpace: "preserve"
  }, props), sumup_style || (sumup_style = /*#__PURE__*/react.createElement("style", null, ".sumup_svg__st0{fill:#737373}")), sumup_path || (sumup_path = /*#__PURE__*/react.createElement("path", {
    className: "sumup_svg__st0",
    d: "M111.12 0c31.56 0 63.11-.01 94.67 0 7.44 0 13.34 3.98 15.5 10.6.58 1.79.86 3.76.86 5.65.04 62.91.05 125.82.02 188.73 0 9.43-6.88 16.25-16.3 16.25-63.16.01-126.33.01-189.49 0-9.48 0-16.37-6.91-16.37-16.37C0 142.07 0 79.26 0 16.45 0 6.89 6.87.02 16.45.01 48.01-.01 79.56 0 111.12 0zm43.61 128.84c.05-11.01-3.92-22.56-12.1-32.64-1.9-2.35-4.04-2.47-6.18-.34-22.53 22.43-45.07 44.86-67.6 67.29-2.23 2.22-2.15 4.17.26 6.12 12.67 10.25 27.05 14.09 43.11 11.29 23.74-4.15 42.1-25.71 42.51-51.72zM67.07 91.46c-.07 11.24 3.83 22.76 12.05 32.77 2.08 2.52 4.15 2.58 6.51.23 22.51-22.41 45.02-44.81 67.52-67.22 2.11-2.1 2.08-3.3-.25-5.21-12.81-10.54-27.39-14.6-43.75-11.66-23.75 4.27-41.57 25.29-42.08 51.09zM494.34 70.34c3.71-3.57 7.89-6.14 12.72-7.61 17.83-5.45 36.06 6.08 38.72 24.53.18 1.25.2 2.52.21 3.78.01 19.42.03 38.84.01 58.25-.01 6.15-5.1 10.27-10.8 8.81-3.34-.85-5.96-3.9-6.31-7.37-.07-.7-.07-1.41-.07-2.12 0-18.86 0-37.72-.01-56.59 0-6.43-3.42-11.36-9.02-13.12-8.59-2.7-17.21 3.67-17.22 12.81-.03 19.17-.01 38.33-.01 57.5 0 4.36-2.44 7.81-6.22 8.86-5.14 1.43-10.04-2.08-10.55-7.56-.06-.65-.05-1.31-.05-1.97 0-18.76 0-37.52-.01-56.28 0-6.35-3.56-11.42-9.13-13.05-8.86-2.6-17.06 3.52-17.11 12.84-.05 9.56-.01 19.11-.01 28.67 0 9.61.03 19.22-.01 28.82-.03 6.36-6.01 10.52-11.74 8.25-3.32-1.31-5.41-4.48-5.44-8.36-.03-5.31-.01-10.62-.01-15.93 0-13.81-.04-27.61.01-41.42.05-14.4 8.91-26.17 22.49-29.66 10.18-2.61 19.41-.35 27.6 6.21.62.51 1.22 1.06 1.96 1.71zM661.22 154.23v1.85c0 13.95.01 27.91-.01 41.86-.01 4.55-2.9 8.03-7.21 8.81-4.49.81-9.08-2.42-9.82-6.94-.14-.84-.18-1.71-.18-2.57-.01-34.83-.02-69.67 0-104.5.01-15.33 9.65-27.58 24.46-30.63 17.04-3.51 32.77 6.14 36.23 22.6.45 2.16.69 4.41.7 6.61.07 11.78.22 23.56-.02 35.34-.26 12.97-5.89 23-17.69 28.88-7.43 3.7-15.25 3.99-23.03.71-.6-.25-1.17-.59-1.74-.92-.5-.3-.98-.64-1.69-1.1zm.78-44.14h.06c0 6.42-.14 12.84.04 19.25.17 5.8 3.67 9.87 9.24 11.03 1.76.37 3.62.48 5.42.38 7.09-.37 11.91-4.95 12-11.75.16-12.68.13-25.37.01-38.05-.04-4.37-2.2-7.84-5.9-10.2-8.84-5.65-20.48.37-20.83 10.85-.2 6.15-.04 12.32-.04 18.49zM422.9 100.29c0 9.05.04 18.1-.01 27.15-.08 15.17-10.48 27.5-25.38 30.14-18.6 3.3-35.78-10.57-35.99-29.42-.22-19.41-.08-38.83-.04-58.24.01-5.04 3.87-8.89 8.66-8.87 4.88.02 8.55 3.92 8.55 9.11.01 19.21-.02 38.43.02 57.64.01 5.72 2.7 9.94 7.93 12.18 5.32 2.28 10.42 1.54 14.84-2.32 3-2.62 4.18-6.09 4.17-10.03-.01-14.26 0-28.52 0-42.77 0-5.01-.04-10.01.02-15.02.04-3.65 2.5-6.87 5.93-7.99 3.51-1.14 7.42.08 9.63 3.01 1.29 1.7 1.66 3.64 1.66 5.71.01 9.9.01 19.81.01 29.72zM626.8 100.56c0 8.95.04 17.9-.01 26.85-.08 15.43-10.89 27.97-26.09 30.33-18.31 2.84-35.07-11.04-35.28-29.56-.21-19.41-.07-38.83-.04-58.25.01-5.04 3.86-8.9 8.66-8.88 4.87.02 8.56 3.92 8.57 9.1.01 19.22-.01 38.43.01 57.65 0 5.8 3.3 10.53 8.62 12.5 5.43 2.02 11.58.52 15.23-3.72 2.25-2.62 3.11-5.7 3.11-9.11-.02-18.86-.02-37.72.01-56.58 0-1.19.12-2.45.48-3.57 1.31-4.05 5.23-6.42 9.34-5.77 4.34.68 7.36 4.22 7.37 8.84.05 10.04.02 20.11.02 30.17zM316.47 61.77c9.98.53 19.36 4.96 26 14.5 1.49 2.14 1.36 4.61.56 7-1.7 5.04-8.96 8.25-13.83 3.35a33.23 33.23 0 01-2.03-2.25c-4.38-5.26-11.41-7.15-17.84-4.78-3.97 1.46-6.12 4.58-5.92 8.55.12 2.55 1.46 4.49 3.52 5.71 2.99 1.76 6.11 3.31 9.27 4.76 5.68 2.61 11.59 4.75 17.09 7.69 7.08 3.78 11.9 9.63 13.54 17.71 2.46 12.12-2.13 22.9-12.9 29.02-13.63 7.74-27.33 7.31-40.56-1.11-2.39-1.52-4.34-3.92-6.07-6.24-2.5-3.34-1.89-7.55 1.09-10.46 3.08-3.02 7.4-3.51 10.8-1.2.7.48 1.4 1.03 1.95 1.67 4.57 5.32 10.5 6.41 17.06 5.5 3.17-.44 6.05-1.62 8.4-3.85 4.6-4.37 4.54-10.95-.52-14.76-2.82-2.13-6.13-3.67-9.38-5.14-4.82-2.18-9.84-3.94-14.67-6.1-3.76-1.68-7.07-4.07-9.94-7.07-8.73-9.11-8.78-28.59 5.55-37.54 5.31-3.34 11.13-4.88 18.83-4.96zM728.39 78.92c-.39-9.19 7.18-17.06 16.84-17.51 9-.42 17.17 7.16 17.58 16.3.43 9.65-6.93 17.79-16.44 18.17-9.73.39-17.56-6.99-17.98-16.96zm4.33-.31c-.02 7.2 5.68 12.96 12.84 12.99 7.11.03 12.95-5.76 12.98-12.9.03-7.16-5.68-12.91-12.89-12.96-7.18-.04-12.91 5.66-12.93 12.87z"
  })), sumup_path2 || (sumup_path2 = /*#__PURE__*/react.createElement("path", {
    className: "sumup_svg__st0",
    d: "M747.5 79.49c1.01 1.14 1.93 2.14 2.81 3.17.86 1.01.86 2.14.04 2.8-.82.65-2.28.5-2.98-.36-1.34-1.64-2.64-3.31-4.28-5.36 0 1.59-.02 2.75 0 3.91.02 1.23-.43 2.09-1.76 2.18-1.18.08-1.84-.72-1.85-2.24-.02-3.69-.02-7.37 0-11.06.01-1.54.59-2.09 2.11-2.12 1.41-.02 2.83-.03 4.24.01 2.74.07 4.6 1.43 5.06 3.68.49 2.28-.61 4.1-3.39 5.39zm-3.65-2.71c1.39-.02 2.84.56 3.62-.95.24-.48.21-1.4-.11-1.81-.9-1.18-2.22-.74-3.51-.63v3.39z"
  })));
}
/* harmony default export */ var sumup = (SvgSumup);
;// CONCATENATED MODULE: ./public/artifacts/icons/logo/taxfix.svg
var taxfix_style, taxfix_g;
function taxfix_extends() { return taxfix_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, taxfix_extends.apply(null, arguments); }

function SvgTaxfix(props) {
  return /*#__PURE__*/react.createElement("svg", taxfix_extends({
    id: "taxfix_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 513 143.78",
    xmlSpace: "preserve"
  }, props), taxfix_style || (taxfix_style = /*#__PURE__*/react.createElement("style", null, ".taxfix_svg__st16{fill:#565b58}")), taxfix_g || (taxfix_g = /*#__PURE__*/react.createElement("g", {
    id: "taxfix_svg__jEkIyv_tif"
  }, /*#__PURE__*/react.createElement("path", {
    className: "taxfix_svg__st16",
    d: "M431.83 143.78c-6.25-5.72-12.51-11.43-18.92-17.29 11.29-11.25 21.46-21.38 31.53-31.42C434 84.65 424.11 74.8 414.22 64.93c6.47-6.54 12.29-12.42 18.08-18.28l29.55 29.73c10.78-10.88 20.79-20.99 30.53-30.82 6.56 6.61 12.49 12.59 18.77 18.91-7.24 7.23-14.93 14.9-22.62 22.58-7.24 7.24-7.24 7.25.01 14.49 7.79 7.79 15.59 15.57 24.46 24.43-6.55 6.1-12.83 11.96-19.11 17.81h-.85c-4.17-4.38-8.28-8.83-12.53-13.14-5.75-5.82-11.62-11.53-16.84-16.69-10.43 10.04-20.71 19.94-30.99 29.83h-.85zM0 45.94c1.84-.03 3.69.02 5.52-.1 10.02-.68 14.4-5.84 14.73-17.42.09-3.25.01-6.5.01-10.06h25.15v27.56h18.43v24.59H45.37c0 5.89-.06 11.24.01 16.59.11 7.5.09 15 .56 22.48.28 4.47 3.11 6.79 7.61 7.02 3.22.16 6.45.03 10.16.03 0 7.11.05 14.15-.07 21.19-.01.74-.77 1.79-1.47 2.16-16.48 8.91-41.08-2.95-44.14-21.36-.65-3.88-.78-7.88-.82-11.82-.1-11.88-.04-23.76-.04-36.19H-.01C0 62.39 0 54.16 0 45.94zM388.48 0c1.16.66 2.28 1.41 3.49 1.96 7.32 3.36 11.53 11.31 9.87 18.74-1.69 7.56-8.86 13.3-16.57 13.26-7.68-.04-14.63-5.89-16.21-13.65-1.51-7.42 2.92-15.4 10.27-18.57 1.11-.48 2.14-1.16 3.2-1.74h5.95zM147.98 55.2v-9.03h27.62v94.1h-27.33v-10.02c-4.26 3.37-8.18 8.09-13.19 10.13-14.94 6.1-29.1 2.82-41.26-7.17-24.28-19.93-23.78-62.04 1.04-81.11 12.78-9.82 27.27-12.16 42.3-5.18 3.81 1.8 6.87 5.2 10.82 8.28zm-43.29 37.64c.56 3.46.8 7.03 1.73 10.4 2.5 9 9.75 14.89 18.64 15.54 8.71.64 16.87-4.34 20.54-12.92 3.51-8.19 3.41-16.62.29-24.87-3.45-9.13-11.4-13.59-22.09-12.91-8.21.52-15.18 6.4-17.47 15.04-.82 3.11-1.09 6.38-1.64 9.72zM353.83 27.05c-19.3.33-22.03 3.04-20.48 20.42h20.22v23.78h-20.3v70.62h-28.7V71.54h-15.24v-23.8h14.76c.28-5.11.34-9.74.83-14.32 2.2-20.6 17.25-31.53 37.6-30.97 11.33.31 11.33.42 11.33 11.56-.02 4.23-.02 8.46-.02 13.04zM190.77 125.22c23.02-26.69 45.77-53.08 68.81-79.79 6.62 5.62 13.01 11.05 19.83 16.84-23.11 26.59-46.04 52.97-69.36 79.79-6.43-5.62-12.71-11.1-19.28-16.84zM371.64 46.98h27.97v94.01h-27.97V46.98zM279.81 124.06c0 9.03-7.65 16.8-16.72 16.99-8.67.18-16.66-8.05-16.59-17.09.07-8.89 7.66-16.57 16.49-16.68 8.89-.12 16.82 7.79 16.82 16.78zM207.14 79.98c-8.86-.13-16.73-8.31-16.54-17.17.19-8.66 8.45-16.81 16.75-16.53 9.02.3 17.01 8.31 16.92 16.97-.09 8.74-8.4 16.86-17.13 16.73z"
  }))));
}
/* harmony default export */ var taxfix = (SvgTaxfix);
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/Customers.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n\n  display: flex;\n  gap: ",
        "px;\n  flex-direction: column;\n  max-width: 100%;\n\n  ",
        " {\n    flex-direction: row;\n    gap: 3vw;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: ",
        "px;\n  column-gap: ",
        "px;\n\n  .logo__icon {\n    height: 20px;\n    flex-grow: 0;\n    flex-shrink: 0;\n\n    ",
        " {\n      height: 26px;\n\n      &--cosmo {\n        padding: 2px;\n      }\n\n      &--doctolib {\n        padding: 3px;\n      }\n      &--bitkom {\n        padding: 5px;\n      }\n\n      &--taxfix {\n        padding: 3px;\n      }\n\n      &--helloFresh {\n        padding: 3px;\n      }\n    }\n\n    ",
        " {\n      height: 30px;\n    }\n  }\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n\n  ",
        " {\n    flex-wrap: nowrap;\n    gap: 2vw;\n  }\n\n  ",
        " {\n    gap: 2.5vw;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var Customers = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogosWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sumup, {
                    className: "logo__icon logo__icon--sumup"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(cosmoconsult, {
                    className: "logo__icon logo__icon--cosmo"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(celonis2, {
                    className: "logo__icon logo__icon--celonis"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(docotlib, {
                    className: "logo__icon logo__icon--doctolib"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(c_and_a, {
                    className: "logo__icon logo__icon--c&a"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bitkom, {
                    className: "logo__icon logo__icon--bitkom"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(helloFresh, {
                    className: "logo__icon logo__icon--helloFresh"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(taxfix, {
                    className: "logo__icon logo__icon--taxfix"
                })
            ]
        })
    }));
};
var Wrapper = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var LogosWrapper = styled_components_browser_esm["default"].div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up(1480);
});
/* harmony default export */ var foodProgram_Customers = (Customers);


/***/ }),

/***/ 54397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ FoodProgramH1; },
/* harmony export */   "s": function() { return /* binding */ FoodProgramH2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  line-height: 1.6;\n  font-size: 18px;\n\n  ",
        " {\n    font-size: 24px;\n  }\n\n  ",
        " {\n    font-size: 36px;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var FoodProgramH1 = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        variant: "h1",
        lineHeight: {
            xs: 1.5,
            md: 1.1
        },
        fontSize: {
            xs: 40,
            md: 48
        },
        component: "h1"
    }, props));
};
var FoodProgramH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        component: "h2"
    }, props));
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});


/***/ }),

/***/ 31006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useFoodProgramCta; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var FOOD_PROGRAM_CTA_HREF = {
    en: "https://calendly.com/food-program/15min",
    de: "https://calendly.com/food-program/15min"
};
function useFoodProgramCta() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().locale;
    if (locale === "en") {
        return FOOD_PROGRAM_CTA_HREF.en;
    }
    return FOOD_PROGRAM_CTA_HREF.de;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,4658,5675,2052,8107,9774,2888,179], function() { return __webpack_exec__(21972); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);